
window.$ = window.jQuery = require('jquery');

window.Swal = require('sweetalert2')

import 'bootstrap';
import 'daterangepicker';
import 'moment';
import 'slick-carousel';

require('jquery-visible')
require('jquery.animate-number')
require('jsrender')
require('./dialogs/confirm_dialog')
require('./dialogs/loading_dialog')
require('./numberAnimate')
require('./web_function')
